module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("ABBREVIATIONS")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("ACCS")])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Ancient Christian Commentary on Scripture")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("ACD")])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Ancient Christian Doctrine")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("ACW")])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Ancient Christian Writers")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("ANF")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Ante-Nicene Fathers")])])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("CSEL")])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Corpus Scriptorum Ecclesiasticorum Latinorum")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("EAC")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Encyclopedia of Ancient Christianity")]), _vm._v(". Edited by Angelo Di Berardino. Downers Grove, IL: IVP Academic, 2014")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("NPNF"), _c('sup', [_vm._v("1")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers")]), _vm._v(", Series 1")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("NPNF"), _c('sup', [_vm._v("2")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers")]), _vm._v(", Series 2")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("PG")])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Patrologia Cursus Completus: Series Graeca. Edited by Jacques-Paul Migne. 162 vols. Paris, 1857–1886")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("SC")])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Sources chrétiennes")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 75
// module chunks = 0